import { authAxios } from '@components/Auth';
import { API_V1_BASE } from '@config';
import { Hospital } from '@models/BusinessPartner';
import { paginate, Pagination, PaginationParams } from '@models/Pagination';
import { snakes } from '@utils/lodash';

export type HospitalNetworkSearchParams = PaginationParams & {
  search?: string;
  province?: string;
  healthPlanId?: string;
};

export class HospitalNetworkApi {
  static getAll = async (params = {} as HospitalNetworkSearchParams) => {
    return await authAxios
      .get(`${API_V1_BASE}/hospital_networks`, { params: snakes(params) })
      .then((response) => paginate(response) as [Hospital[], Pagination]);
  };
}
